import React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from '../../../lib/cn';

export function Collapsible(props: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root {...props} />;
}

export function CollapsibleTrigger(
  props: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>,
) {
  return <CollapsiblePrimitive.CollapsibleTrigger {...props} />;
}

export function CollapsibleContent(
  props: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>,
) {
  return <CollapsiblePrimitive.CollapsibleContent {...props} />;
}

export function CollapsibleRow({
  open,
  onOpenChange,
  title,
  subtitle,
  index,
  children,
  className,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  subtitle?: string;
  index: number;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className={cn('studio-collapsible', className)}>
      <CollapsibleTrigger className="studio-collapsible__trigger">
        <span className="studio-collapsible__index">{index + 1}</span>
        <span className="studio-collapsible__meta">
          <span className="studio-collapsible__title">{title || `Paso ${index + 1}`}</span>
          {subtitle && !open && (
            <span className="studio-collapsible__subtitle">{subtitle}</span>
          )}
        </span>
        <span className="studio-collapsible__chevron" aria-hidden>
          {open ? '−' : '+'}
        </span>
      </CollapsibleTrigger>
      <CollapsibleContent className="studio-collapsible__content">{children}</CollapsibleContent>
    </Collapsible>
  );
}
